import React from "react";
import "./App.scss";
import { OrientationProvider } from "./provider/OrientationProvider";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import NoMatch from "./view/NoMatch";
import { IUABrowser, userAgentInfo } from "./model/UserAgentInfo";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import Plane from "./view/Plane";
import WhatIsMoire from "./view/WhatIsMoire";

const App: React.FC = () => {

	return (
		<OrientationProvider>
			{(() => {
				// IEとか、対象外のブラウザだったらPLANE版を表示
				if ( userAgentInfo.browser === IUABrowser.ie || userAgentInfo.browser === IUABrowser.other ) {
					return <Plane
						alertMessage="※ サポート対象外のブラウザのため、動作しません。他のブラウザでご覧ください。"
					/>;
				}
				// サポート対象外のOSバージョンだったら
				if ( !userAgentInfo.supportedOSVersion ) {
					return <Plane
						alertMessage="※ サポート対象外のOSのため、動作しません。OSを更新するか、他の端末でご覧ください。"
					/>;
				}

				return <Router>
					<Switch>
						<Route exact path="/" component={WhatIsMoire}/>
						<Route path="*" component={NoMatch}/>
					</Switch>
				</Router>;
			})()}
		</OrientationProvider>
	);
};

export default App;
